<mat-form-field class="w-100 calendar">
    <button mat-icon-button matPrefix (click)="otherDay(-1)">
        <mat-icon>chevron_left</mat-icon>
    </button>

    <input matInput [matDatepicker]="picker" [formControl]="dateControl">

    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>

    <button mat-icon-button matSuffix (click)="otherDay(1)">
        <mat-icon>chevron_right</mat-icon>
    </button>
</mat-form-field>
